// extracted by mini-css-extract-plugin
module.exports = {"productPic":"device_productPic__3hz1X","option":"device_option__2EYQn","btnlist":"device_btnlist__31ilf","warp":"device_warp__3h84s","proTable":"device_proTable__3Mrmf"};